import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatbotRegularAi from './chatbot-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChatbotRegularAi {...validProps} />;
}
SvgComponent.iconName = 'chatbotRegularAi';

export const ChatbotRegularAiIcon = svgIconWrapper(SvgComponent);
